import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { Tabs } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/ChameleonElement';
export class TabsComponent extends ChameleonElementMixin(Tabs) {
    connectedCallback() {
        super.connectedCallback();
    }
    fullwidthChanged(oldValue, newValue) {
        this.classList.toggle('full-width', newValue);
    }
    tabsChanged() {
        super.tabsChanged();
        if (!this.activeid && this.tabs.length !== 0) {
            this.activeid = this.tabs[0].id !== '' ? this.tabs[0].id : 'tab-1';
        }
    }
}
__decorate([
    attr({ mode: 'boolean' })
], TabsComponent.prototype, "fullwidth", void 0);
